import * as React from 'react';
import ContactPageView from '../layouts/ContactUsView';

export interface ContactPageProps {

}

class ContactPage extends React.Component<ContactPageProps> {
  render() {
    return <ContactPageView />;
  }
  componentDidMount() {
    //
  }
}

export default ContactPage;



// WEBPACK FOOTER //
// ./src/components/contactus/ContactPage.tsx